export enum Locales {
  en = 'en',
  fr = 'fr',
  es = 'es',
  sv = 'sv',
  zhHans = 'zh-Hans',
  zhHant = 'zh-Hant'
}

export enum AlertTypes {
  MEDICAL = 'medical',
  COMPLIANCE = 'compliance'
}

export enum AlertsSortingFilters {
  NAME = 'NAME',
  SEVERITY = 'SEVERITY',
  ALERT_COUNT = 'ALERT_COUNT',
  DATE = 'DATE'
}

export enum DeviceStatus {
  ORDERED = 'ordered',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  REPLACED = 'replaced',
  SUSPENDED = 'suspended',
  RETIRED = 'retired'
}

export enum DeviceOrderingsStatus {
  ACTIVE = 'active',
  DISCONTINUED = 'discontinued',
  INACTIVE = 'inactive'
}

export enum DeviceTypes {
  ASSIGNED = 'assigned',
  UNASSIGNED = 'unassigned',
  DELETED = 'deleted'
}

export enum DeviceConditions {
  FUNCTIONAL = 'functional',
  FAULTY = 'faulty',
  BROKEN = 'broken',
  LOST = 'lost'
}

export enum DeviceLocations {
  UNKNOWN = 'unknown',
  OFFICE = 'office',
  PATIENT_HOME = 'patient_home'
}

export enum AccessRoles {
  ADMIN = 1,
  SYSOP = 2,
  SUPPORT = 5,
  GROUP_MANAGEMENT = 10,
  BILLING = 12
}

export enum LogoutRedirectionURLs {
  SEIDP = '/api/logout-se-idp',
  SITHS = '/api/logout-siths'
}

export enum OAuthCode {
  TFA_CODE_REQUIRED = '67',
  TFA_PHONE_MISSING = '68',
  TFA_CODE_NOT_FOUND = '81',
  TFA_CODE_NO_MATCH = '82',
  TFA_CODE_EXPIRED = '83'
}

export enum GroupManagementTabs {
  CONFIGURATION = 'configuration',
  BILLING_CONFIGURATION = 'billing-configuration',
  CARE_PLAN = 'care-plan',
  QUESTIONNAIRES = 'questionnaires',
  SMART_EVENTS_LIST = 'smart-events',
  USER_MANAGEMENT = 'user-management',
  WHITELABEL = 'whitelabel',
  DEVICE_SELECTION = 'devices-selection',
  DOCUMENTS = 'documents'
}

export enum BillingTabs {
  OVERVIEW = 'overview',
  ACTIVITY = 'activity',
  CREDITS = 'credits',
  INVOICES = 'invoices',
  RATES = 'rates',
  SETTINGS = 'settings'
}

export enum UserManagementTabs {
  ADD = 'add',
  EDIT = 'edit'
}

export enum QuestionnaireBuilderTabs {
  BUILDER = 'builder',
  COPY = 'builder/copy',
  EDIT = 'builder/edit'
}

export enum ClinicalLogTypes {
  ALERTS_CLOSED = 'alert',
  TIME_LOG = 'timeLog',
  NOTE = 'note',
  MESSAGE = 'message',
  CARE_PLAN = 'carePlan',
  REPORT = 'report',
  TASKS = 'tasks'
}

export enum AnalyticsTabs {
  DASHBOARD = 'dashboard',
  REPORTS = 'reports'
}
export enum TimerStatus {
  RUNNING = 'RUNNING',
  PAUSED = 'PAUSED',
  STOPPED = 'STOPPED'
}

export enum PatientTabs {
  ALERTS = 'alerts',
  VITALS = 'vitals',
  CLINICAL_LOGS = 'clinical-logs',
  MESSAGING = 'messaging',
  CARE_PLAN = 'care-plan',
  INFORMATION = 'information',
  DEVICES = 'devices',
  SURVEYS = 'surveys',
  REPORTS = 'reports',
  DOCUMENTS = 'documents',
  TASKS = 'tasks',
  SUPPORT = 'support'
}

export enum ERHIntegrationType {
  NONE = 0,
  ONE_WAY = 1,
  TWO_WAY = 2
}

export enum OperatorCode {
  NOT_EQUAL = 0,
  EQUAL = 1,
  LESS_THAN = 2,
  LESS_THAN_OR_EQUAL = 3,
  GREATER_THAN = 4,
  GREATER_THAN_OR_EQUAL = 5,
  IN = 6
}

export enum ReportStatus {
  IN_PROGRESS = 0,
  READY = 1,
  EHR_UPLOAD_SUCCESS = 2,
  ERROR = 90,
  EXPORT_LIMIT = 91,
  EHR_UPLOAD_FAILURE = 92,
  CHILD_REPORTS_ERROR = 93,
  DELETED = 99
}

export enum CallRoles {
  ADMIN = 0,
  INVITE = 1
}

export enum CallStatus {
  SCHEDULED = 0,
  STARTED = 1,
  ENDED = 2,
  ERROR = 3
}

export enum SmartEventActionType {
  ALERT = 'alert',
  MEASUREMENT = 'task_observation',
  QUESTIONNAIRE = 'task_questionnaire',
  MESSAGE = 'task_message'
}

export enum SmartEventConditionType {
  MEASUREMENT = 'observation_value',
  QUESTIONNAIRE = 'questionnaire_score',
  DATE = 'date',
  COMPLIANCE = 'compliance',
  PROFILE = 'profile',
  BASELINE = 'baseline_change_pct'
}

export enum SmartEventBaselineComponent {
  SYSTOLIC = 'systolic',
  DIASTOLIC = 'diastolic',
  EITHER = 'either'
}

export enum SmartEventCondition {
  REACH_DATE = 'reach',
  RECURRING_DATE = 'recurring',
  NOT_EQUALS = '0',
  EQUALS = '1',
  LESS_THAN = '2',
  LESS_THAN_EQUAL = '3',
  GREATER_THAN = '4',
  GREATER_THAN_EQUAL = '5',
  INCREASE = 'increase',
  DECREASE = 'decrease',
  INCREASE_FROM_REF = 'increase_from_ref',
  DECREASE_FROM_REF = 'decrease_from_ref',
  INCREASE_OVER_TIME = 'increase_over_time',
  DECREASE_OVER_TIME = 'decrease_over_time',
  BASELINE_RISE = 'baseline_rise',
  BASELINE_DROP = 'baseline_drop',
  BASELINE_ANY = 'baseline_any'
}

export enum SmartEventDateTarget {
  PREGNANCY_WEEKS = 'pregnancy_start_date',
  ONBOARDING_DAYS = 'onboarding_date',
  TIME_SINCE_REFERRED = 'timeSinceStatus@0',
  TIME_SINCE_DEVICE_ORDERED = 'timeSinceStatus@10',
  TIME_SINCE_DEVICE_SHIPPED = 'timeSinceStatus@20',
  TIME_SINCE_FIRST_READING_TRANSMITTED = 'timeSinceStatus@40',
  TIME_SINCE_ENROLLED = 'timeSinceStatus@500',
  TIME_SINCE_PAUSED = 'timeSinceStatus@200',
  TIME_SINCE_TO_BE_ARCHIVED = 'timeSinceStatus@100'
}

export enum SmartEventComplianceTarget {
  NO_MEASUREMENTS_SINCE = 'latestObservationDaysAgo'
}

export enum SmartEventProfileTarget {
  PATIENT_STATUS = 'patientStatus'
}

export enum SmartEventValueType {
  ABSOLUTE = 'absolute',
  PERCENTAGE = 'percentage'
}

export enum SmartEventStep {
  SUMMARY = 'smartEventDescriptionKey',
  CONDITIONS = 'conditionsKey',
  ACTIONS = 'actionsKey',
  REVIEW = 'reviewAndConfirmKey'
}

/** Amazon MCF shipping speed on a patient shipment (PHX-1320). Wire values match the API. */
export enum ShippingSpeed {
  STANDARD = 'standard',
  EXPEDITED = 'expedited'
}

export enum FulfillmentStatus {
  RECEIVED = 'received',
  PLANNING = 'planning',
  PROCESSING = 'processing',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  EXCEPTION = 'exception'
}

export enum InviteType {
  INVITE_ONLY = 'inviteOnly',
  INVITE_WITH_DEVICE = 'inviteWithDevice',
  ORDER_PATIENT_DEVICE = 'addDevice',
  BULK_ORDER_DEVICES = 'bulkOrderDevices',
  BULK_ORDER_ACCESSORIES = 'bulkOrderAccessories'
}

export enum InvitationStep {
  SELECT_GROUP_AND_TYPE = 'groupKey',
  MEDICAL_INFORMATION = 'medicalInformationKey',
  CARE_PROGRAM = 'selectProgramsKey',
  DEMOG_INFO = 'demographicInformationKey',
  DEVICES = 'medicalDevicesKey',
  ACCESSORIES = 'accessoriesKey',
  SHIPPING_INFO = 'shippingInformationKey',
  CARE_PLAN = 'carePlansKey',
  REVIEW_AND_CONFIRM = 'reviewAndConfirmKey'
}

export enum AdminInvitationStep {
  USER_INFO = 'usersKey',
  GROUP_AND_PERMISSIONS = 'permissionsKey',
  REVIEW_AND_CONFIRM = 'reviewAndConfirmKey'
}

export enum PDFName {
  AMBULATORY_VITALS = 'ambulatory-vitals'
}

export enum CareProgramTypes {
  MONITORING = 'monitoring',
  MANAGEMENT = 'management',
  COACHING = 'coaching'
}

export enum EHRSystems {
  EPIC = 'EPIC',
  NEXTGEN = 'NextGen',
  ATHENA = 'Athenahealth',
  GENERIC_3P = 'GENERIC_3P'
}

export enum GlucoseMgDlConvert {
  GL = 100,
  MMOL = 18.0182
}

export enum GlucoseUnit {
  GL = 'g/L',
  MGDL = 'mg/dL',
  MMOL = 'mmol/L'
}

export enum PatientStatus {
  REFERRED = '0',
  DEVICE_ORDERED = '10',
  DEVICE_SHIPPED = '20',
  FIRST_READING_TRANSMITTED = '40',
  PAUSED = '200',
  ENROLLED = '500',
  TO_BE_ARCHIVED = '100',
  ARCHIVED = '110',
  OFF_BOARDED = '150'
}

export enum TimelogTypes {
  RPM = 'a956b78e-a358-423c-9187-a7bde09073fa',
  RPM_NURSE = '7fd1ed27-ffa2-4799-bc9d-246be2181997',
  CCM = 'e399e025-b13c-4d77-b5b7-23879462b58d',
  PCM = '26adbec1-ed03-4c34-b45f-4fec9d700247',
  OTHER = '09b0478e-3b02-468b-9737-019ba29b25ef'
}

export enum SurveyStatus {
  DRAFT = 0,
  PUBLISHED = 1
}

export enum TaskType {
  CLINICAL = 0
}

export enum TaskStatus {
  DUE = '1',
  OVERDUE = '2',
  ON_HOLD = '4',
  ACTIVE = '0',
  COMPLETED = '3',
  ARCHIVED = '5'
}

export enum TaskTriggerEvent {
  ON_APPLY = 'onApply',
  ON_STATUS_CHANGE = 'onPatientStatusChange'
}

export enum TaskTimeFilter {
  TODAY = '0',
  THIS_WEEK = '1',
  NEXT_WEEK = '2',
  THIS_MONTH = '3',
  NEXT_MONTH = '4'
}

export enum OrgStatus {
  ACTIVE = 1,
  OUTSTANDING_INVOICES = 2,
  DUNNING = 3,
  SUSPENDED = 4,
  /**
   * Provisioned, but the practice's NPI has not been confirmed against the national registry
   * [F-02]. Not a further rung on the dunning ladder above — a different question, which is why
   * the 7000 decides precedence against SUSPENDED explicitly rather than by ordering.
   */
  VERIFICATION_PENDING = 5
}

export enum OrgStatusError {
  SUSPENDED = '199',
  DUNNING = '198',
  OUTSTANDING_INVOICES = '197'
}

export enum DeviceEventType {
  ORDERED = 'Ordered',
  SHIPPED = 'Shipped',
  DELIVERED = 'Delivered',
  ASSIGNED = 'Assigned',
  UNASSIGNED = 'Unassigned',
  FIRST_TRANSMISSION = 'FirstTransmission',
  REPLACED_BY = 'ReplacedBy',
  REPLACES = 'Replaces',
  REPLENISHMENT_SHIPPED = 'ReplenishmentShipped',
  CANCELLED = 'Cancelled',
  SUSPENDED = 'Suspended',
  REACTIVATED = 'Reactivated',
  AUTO_REACTIVATED = 'AutoReactivated',
  FULFILLMENT_STATUS = 'FulfillmentStatus'
}

export enum TicketStatus {
  OPEN = 'open',
  PENDING = 'pending',
  SOLVED = 'solved',
  CLOSED = 'closed'
}

export enum SystemTasks {
  ATHENA_ORDERS = 'EHR_SIGNEDOFF_CCM_ORDERS'
}

export enum ComparisonOperator {
  LT = 'lt',
  LTE = 'lte',
  EQ = 'eq',
  GTE = 'gte',
  GT = 'gt'
}

export enum SimAction {
  SUSPEND = 'suspend',
  DEACTIVATE = 'deactivate'
}
